import React from 'react';
import PropTypes from 'prop-types';
// common components
import CustomAvatar from './../../../common/Avatar/Avatar';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
import './TrainerList.scss';
const TrainerList = ({ trainerList, manageTrainer }) => { 	
	if (trainerList && trainerList.length > 0) {
		return (
			<div className="TrainerList">
				{trainerList.map(item =>
					<div className="row card-view" key={item.id}>
						<div className="col col-lg-3 card-heading one">
							<CustomAvatar name={`${item.firstname} ${item.lastname}`} />
							<div className="heading">
								<div className="title" onClick={() => {}}>{item.firstname}&nbsp;{item.lastname}</div>
							</div>
						</div>
						<div className="col-12 col-lg details two">
							<div className="row card-detail">
                				<div className="col col-md-4 col-lg">
									<div className="title">E-mail</div>
									<div className="value">{item.email}</div>
								</div>		
							</div>
						</div>
						<div className="col cardview-actions three">
							<div className="line" />
							<CustomButton
								iconOnly
								iconName='edit'														
								onClick={() => manageTrainer(true, 'edit', item.id)}
							/>
							<CustomButton
								iconOnly
								iconName='delete'									
								onClick={() => manageTrainer(true, 'delete', item.id)}
							/>
						</div>
					</div>
				)}
			</div>
		);
	}
	return (<Loader />);
}

TrainerList.propTypes = {
	trainerList: PropTypes.instanceOf(Array),
	manageTrainer: PropTypes.func
};

TrainerList.defaultProps = {
	trainerList: [],
	manageTrainer: () => { }
};

export default TrainerList;




// WEBPACK FOOTER //
// ./components/Trainer/TrainerList/TrainerList.js